const API = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:4000";

export async function generateUpload(file: File, userId: string) {
  const r = await fetch(`${API}/generate-upload-url`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileName: file.name, fileType: file.type, userId }),
  });
  if (!r.ok) throw new Error("Failed to get upload URL");
  return r.json() as Promise<{ url: string; key: string; expiresAt?: string }>;
}

export async function putToS3(url: string, file: File) {
  const r = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!r.ok) throw new Error("Upload failed");
}

export async function recordUpload(userId: string, key: string, contentType: string, bytes?: number) {
  const r = await fetch(`${API}/upload-complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId, key, contentType, bytes }),
  });
  if (!r.ok) throw new Error("Failed to record upload");
  return r.json();
}

export async function getVault(userId: string, cursor?: string, limit = 20) {
  const url = new URL(`${API}/vault`);
  url.searchParams.set("userId", userId);
  url.searchParams.set("limit", String(limit));
  if (cursor) url.searchParams.set("cursor", cursor);
  const r = await fetch(url);
  if (!r.ok) throw new Error("Failed to fetch vault");
  return r.json() as Promise<{ items: any[]; nextCursor: string | null }>;
}

export async function getDownloadUrl(key: string) {
  const r = await fetch(`${API}/generate-download-url`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key }),
  });
  if (!r.ok) throw new Error("Failed to generate download URL");
  return r.json() as Promise<{ url: string }>;
}
